import { Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import useTrackerAccess from './hooks/useTrackerAccess';
import { VIEWS, VIEW_PATHS } from './utils/trackerConstants';

// Entry for the existing sidebar link: sends each side to its own page.
//   TA wing head  → /my-workspace/tutor-replacement-ta-head       (assign to the TA wing, project-scoped; the page itself is open to anyone)
//   TA associate  → /my-workspace/tutor-replacement-ta-associate  (progress update on rows assigned to them)
//   anyone else   → /my-workspace/tutor-replacement-cro           (their own students, read-only)
// The project-wise analytics is on the dashboard: /dashboard/tutor-replacement-analytics.
export default function TutorReplacementTracker() {
  const access = useTrackerAccess();

  if (!access.loaded) {
    return (
      <Box display="flex" justifyContent="center" py={6}>
        <CircularProgress size={28} />
      </Box>
    );
  }
  const view = access.isTaWing && access.isHead ? VIEWS.HEAD : access.isTaWing ? VIEWS.MINE : VIEWS.CRO;
  return <Navigate to={VIEW_PATHS[view]} replace />;
}
